import { useNewListingPrompt } from 'app/hooks/use-new-listing-prompt';
import { useUISize } from 'app/utils/web-helpers';
import type { ComponentProps } from 'react';
import { NewListingPrompt as NewListingPromptLarge } from './prompt.large';
import { NewListingPrompt as NewListingPromptSmall } from './prompt.small';

export { useNewListingPrompt };

export function NewListingPrompt(props: ComponentProps<typeof NewListingPromptSmall>) {
  const { isSmallUI } = useUISize();
  if (isSmallUI) {
    return <NewListingPromptSmall {...props} />;
  }
  return <NewListingPromptLarge {...props} />;
}
